export class ReportKindInfo
{ 
public static reportKinds = [
    {
      value: 'print',
      name: 'چاپ',
    },
    {
      value: 'preview',
      name: 'پیش نمایش',
    },
    {
      value: 'editReport',
      name: 'اصلاح گزارش',
    },
    {
      value: 'copyReport',
      name: 'تکثیر گزارش',
    },
    {
      value: 'deleteReport',
      name: 'حذف گزارش',
    }
  ];
}